import {
  USER_ADMIN_ADD_FAVOURITE,
  USER_ADMIN_FETCH_ALL_CONTACT,
  USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  USER_ADMIN_FILTER_CONTACT,
  USER_ADMIN_GET_ALL_CONTACT,
  USER_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  USER_ADMIN_HANDLE_REQUEST_CLOSE,
  USER_ADMIN_HIDE_CONTACT_LOADER,
  USER_ADMIN_ON_ADD_CONTACT,
  USER_ADMIN_ON_ALL_CONTACT_SELECT,
  USER_ADMIN_ON_CONTACT_CLOSE,
  USER_ADMIN_ON_CONTACT_SELECT,
  USER_ADMIN_ON_DELETE_CONTACT,
  USER_ADMIN_ON_DELETE_SELECTED_CONTACT,
  USER_ADMIN_ON_FILTER_OPTION_SELECT,
  USER_ADMIN_ON_SAVE_CONTACT,
  USER_ADMIN_ON_TOGGLE_DRAWER,
  USER_ADMIN_SHOW_MESSAGE,
  USER_ADMIN_UPDATE_SEARCH_USER,
  CHANGE_USER_ADMIN_DISPLAY,
  SET_USER_IMAGE_FILE,
  SUBMIT_NEW_USER_ADMIN,
  SUBMIT_NEW_USER_ADMIN_RESPONSE,
  // HANDLE_DATE_OF_BIRTH,
  FILL_ADMIN_USER_SELECTED_DETAILS,
  CHANGE_ADD_USER_STATE,
  CHANGE_EDIT_USER_STATE,
  SUBMIT_EDIT_USER_DETAILS,
  SUBMIT_EDIT_USER_DETAILS_RESPONSE,
  USER_CLEAR_FORM_DATA,
  SELECTED_USER_DELETE,
  SELECTED_USER_DELETE_RESPONSE,
  USER_FAIL_RESPONSE,
  USER_ON_HIDE_LOADER2,
  USER_ON_SHOW_LOADER,
} from "../constants/ActionTypes";

export const userAdminFetchContacts = () => ({
  type: USER_ADMIN_FETCH_ALL_CONTACT,
});

export const userAdminFetchContactsSuccess = contact => ({
  type: USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  payload: contact,
});
export const userAdminShowContactMessage = message => ({
  type: USER_ADMIN_SHOW_MESSAGE,
  payload: message,
});
export const userAdminAddFavourite = data => ({
  type: USER_ADMIN_ADD_FAVOURITE,
  payload: data,
});
export const userAdminOnContactSelect = data => ({
  type: USER_ADMIN_ON_CONTACT_SELECT,
  payload: data,
});

export const userAdminOnAddContact = () => ({
  type: USER_ADMIN_ON_ADD_CONTACT,
  payload: "",
});
export const userAdminOnContactClose = () => ({
  type: USER_ADMIN_ON_CONTACT_CLOSE,
  payload: "",
});
export const userAdminOnFilterOptionSelect = option => ({
  type: USER_ADMIN_ON_FILTER_OPTION_SELECT,
  payload: option,
});
export const userAdminOnSaveContact = data => ({
  type: USER_ADMIN_ON_SAVE_CONTACT,
  payload: data,
});
export const userAdminOnDeleteContact = data => ({
  type: USER_ADMIN_ON_DELETE_CONTACT,
  payload: data,
});
export const userAdminOnDeleteSelectedContact = () => ({
  type: USER_ADMIN_ON_DELETE_SELECTED_CONTACT,
  payload: "",
});
export const userAdminFilterContact = userName => ({
  type: USER_ADMIN_FILTER_CONTACT,
  payload: userName,
});
export const userAdminGetAllContact = () => ({
  type: USER_ADMIN_GET_ALL_CONTACT,
  payload: "",
});
export const userAdminGetUnselectedAllContact = () => ({
  type: USER_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  payload: "",
});
export const userAdminOnAllContactSelect = () => ({
  type: USER_ADMIN_ON_ALL_CONTACT_SELECT,
  payload: "",
});
export const userAdminUpdateContactUser = userName => ({
  type: USER_ADMIN_UPDATE_SEARCH_USER,
  payload: userName,
});
export const userAdminOnToggleDrawer = () => ({
  type: USER_ADMIN_ON_TOGGLE_DRAWER,
});
export const userAdminHandleRequestClose = () => ({
  type: USER_ADMIN_HANDLE_REQUEST_CLOSE,
});
export const userAdminHideContactLoader = () => ({
  type: USER_ADMIN_HIDE_CONTACT_LOADER,
});

export const changeUserAdminDisplay = payload => ({
  type: CHANGE_USER_ADMIN_DISPLAY,
  payload,
});

export const setUserImageFile = payload => ({
  type: SET_USER_IMAGE_FILE,
  payload,
});

export const submitNewUserAdmin = payload => ({
  type: SUBMIT_NEW_USER_ADMIN,
  payload,
});

export const submitNewUserAdminResponse = payload => ({
  type: SUBMIT_NEW_USER_ADMIN_RESPONSE,
  payload,
});

// export const handleDateOfBirth = payload => ({
//   type: HANDLE_DATE_OF_BIRTH,
//   payload,
// });

export const fillAdminUserSelctedDetails = payload => ({
  type: FILL_ADMIN_USER_SELECTED_DETAILS,
  payload,
});

export const changeAddUserState = payload => ({
  type: CHANGE_ADD_USER_STATE,
  payload,
});

export const changeEditUserState = payload => ({
  type: CHANGE_EDIT_USER_STATE,
  payload,
});

export const submitEditUserDetails = payload => ({
  type: SUBMIT_EDIT_USER_DETAILS,
  payload,
});

export const submitEditUserDetailsResponse = payload => ({
  type: SUBMIT_EDIT_USER_DETAILS_RESPONSE,
  payload,
});

export const userClearFormData = () => ({
  type: USER_CLEAR_FORM_DATA,
});

export const selectedUserDelete = payload => ({
  type: SELECTED_USER_DELETE,
  payload,
});
export const selectedUserDeleteResposne = payload => ({
  type: SELECTED_USER_DELETE_RESPONSE,
  payload,
});

export const userFailResponse = payload => ({
  type: USER_FAIL_RESPONSE,
  payload,
});

export const userOnHideLoader = payload => ({
  type: USER_ON_HIDE_LOADER2,
  payload,
});

export const userOnShowLoader = payload => ({
  type: USER_ON_SHOW_LOADER,
  payload,
});



// WEBPACK FOOTER //
// ./actions/UserAction.js